/**
 * 配置需要挂载到vue.prototype的字段
 */
import api from './api'
import { join } from 'utils/url'
import Vue from 'vue'
import { uploadBigFile } from 'utils/oss'
import { getInfo } from 'utils/IDValidator'
export const prototype = {
  // 私有图片获取接口
  $privateResourcesUrl: join(api.api_server, process.env.VUE_APP_PRIVATE_RESOURCES),
  // 公开图片获取接口
  $publicResourcesUrl: join(api.api_server, process.env.VUE_APP_PUBLIC_RESOURCES),
  // 公开图片下载
  $publicResourcesUrlDownload: join(api.api_server, process.env.VUE_APP_PUBLIC_RESOURCES_DOWNLOAD),
  // 私有图片获取接口
  $privateResourcesUrlDownload: join(api.api_server, process.env.VUE_APP_PRIVATE_RESOURCES_DOWNLOAD),
  //
  $previewResourceUrl: join(api.api_server, process.env.VUE_APP_PREVIEW_RESOURCES),
  // 以上两个接口还可以添加styleName参数，指定图片大小，压缩等情况
  // 服务器地址api
  $apiServer: api.api_server,
  // 移动端域名地址
  $apiServerMobile: api.api_server_mobile,
  // 图片上传api
  $uploadApi: api.api_server + '/messages/api/upload',
  // 图片上传，可通过key参数指定返回数据里的字段名称
  $uploadApiKey: api.api_server + '/messages/api/upload-json',
  // 上传文件工具方法
  $upload: uploadBigFile,
  // 解析身份证，获取信息
  $getIdCardInfo: getInfo
}

Object.keys(prototype).map(key => {
  Vue.prototype[key] = prototype[key]
})
